import styled from "styled-components";
import { Modal } from "antd";
import closeIcon from "../../../../../../assets/icons/close.svg";

export const AlertPopUpCommon = styled(Modal)`
.ant-modal-title {
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  line-height: 1.25;
  letter-spacing: 0.5px;
  font-weight: normal;
  p {
    margin-bottom: 0px
  } 
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    font-weight: ${props => props.theme.fontWeight.bold};
  }
 
}
.ant-modal-header {
  padding-top: 30px;
  border: none;
  border-radius: 0;
  @media only screen and (max-width: 767px) {
    padding-bottom: 0;
  }
}
.ant-modal-close{
  right: 20px;
  top: 15px;
  .ant-modal-close-x{
      width: 20px;
      height: 20px;
      background-image: url(${closeIcon});      
      background-size: 100%;
      i{
        display: none;
      }      
  }
}
.ant-modal-body {
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: #505050;
  text-align: center;
  padding: 15px 50px 20px;
  line-height: 1.5;
  p {
    margin-bottom: 0px
  } 
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    padding: 15px 20px 20px;
  }
}

.ant-modal-footer {
  border-radius: 0;
  border: none;
  padding-bottom: 30px;
}

.ant-modal-footer > div {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}

.ant-modal-content{
  border-radius: 0px;
}

.ant-modal-footer > div > .ant-btn {
  min-width: ${props => props.theme.buttonWidth.primaryButton};  
  border-radius: 0;
  height: 50px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.67;
  color: #fff;
  background-color: #006778;
  letter-spacing: 0.5px;
  flex: auto;
  @media only screen and (max-width: 767px) {
    width: 100%;
    font-size: ${props => props.theme.fontSize.heading};
  }
}

.ant-modal-footer > div > .ant-btn-primary > span {
  color: #fff!;
}
a{
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
}
@media only screen and (max-width: 767px) {
  margin: 0 auto !important;
}
`;

export const AlertPopUpPrimary = styled(AlertPopUpCommon)`
.ant-modal-footer > div > .ant-btn-primary {
  margin-bottom: 15px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
}
.ant-modal-footer > div > .ant-btn:first-child {
  border-radius: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.67;
  height: auto;
  color: #006778;
  border: 0px solid transparent;
  text-decoration: underline;
  background: transparent;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
}

.ant-modal-footer > div > .ant-btn:first-child > span {
  color: #006778;
  text-decoration: underline;
  letter-spacing: normal;
}
`;

export const AlertPopUp = styled(AlertPopUpCommon)`
  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }
`;